import { Extension, RawCommands } from '@tiptap/core';

declare module '@tiptap/core' {
	interface Commands<ReturnType> {
		markdownLink: {
			/**
			 * Insert a markdown link into the editor and focus on the URL segment
			 */
			insertLink: () => ReturnType;
		};
	}
}

export const MarkdownLink = Extension.create({
	name: 'markdownLink',

	addCommands() {
		return {
			insertLink:
				() =>
				({ chain, tr, state }) => {
					const { $from, $to } = tr.selection;

					const from = tr.mapping.map($from.pos);
					const to = tr.mapping.map($to.pos);
					const text = state.doc.cut(from, to).textContent;

					return chain()
						.focus()
						.insertContentAt(
							{ from, to },
							{
								type: 'text',
								text: `[${text}](url)`,
							}
						)
						.setTextSelection({ from: to + 3, to: to + 6 })
						.run();
				},
		} as Partial<RawCommands>;
	},
});
